/* FG product card behaviour: swatch preview + add to cart.
   Delegated from the document, so it also covers cards that arrive later
   from filtering, sorting or pagination without needing to be re-run. */
(function () {
  if (window.__fgCardWired) return;
  window.__fgCardWired = true;

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ---- swatches ---- */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-fgcard-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-fgcard]');
    var img = card && card.querySelector('[data-fgcard-media] img');
    if (!img || !sw.dataset.preview) return;
    if (!card.dataset.baseSrc) {
      card.dataset.baseSrc = img.getAttribute('src') || '';
      card.dataset.baseSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.src = sw.dataset.preview;
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-fgcard-swatch]');
    if (!sw) return;
    if (sw.getAttribute('aria-pressed') === 'true') return;
    var card = sw.closest('[data-fgcard]');
    var img = card && card.querySelector('[data-fgcard-media] img');
    if (!img || !card.dataset.baseSrc) return;
    if (card.dataset.baseSrcset) img.setAttribute('srcset', card.dataset.baseSrcset);
    img.src = card.dataset.baseSrc;
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-fgcard-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-fgcard]');
    if (!card) return;
    card.querySelectorAll('[data-fgcard-swatch]').forEach(function (o) {
      o.setAttribute('aria-pressed', 'false');
    });
    sw.setAttribute('aria-pressed', 'true');
    var img = card.querySelector('[data-fgcard-media] img');
    if (img && sw.dataset.preview) {
      card.dataset.baseSrc = sw.dataset.preview;
      card.dataset.baseSrcset = '';
      img.removeAttribute('srcset');
      img.src = sw.dataset.preview;
    }
  });

  /* ---- add to cart ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fgcard-add]');
    if (!btn || btn.disabled) return;

    var card = btn.closest('[data-fgcard]');
    var label = btn.querySelector('[data-fgcard-add-label]');
    var original = btn.dataset.label || 'ADD TO CART';

    btn.disabled = true;
    if (label) label.textContent = 'Adding...';

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.id), quantity: 1 }],
        sections: 'cart-icon-bubble,cart-drawer,cart-notification',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false;
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 1600);

        var sections = res.sections || {};
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var d1 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var i1 = d1.getElementById('cart-icon-bubble');
          if (i1) bubble.innerHTML = i1.innerHTML;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sections['cart-drawer']) {
          var d2 = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var i2 = d2.querySelector('cart-drawer');
          if (i2) drawer.innerHTML = i2.innerHTML;
          drawer.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        btn.disabled = false;
        if (label) label.textContent = original;
        window.location.href = (card && card.dataset.url) || '/cart';
      });
  });
})();
